import { dealerMonitorStates } from '@racepointenergy/swc/scs/dealer-monitor-states'
import { dealerMonitorUserInterfaces } from '@racepointenergy/swc/scs/dealer-monitor-user-interfaces'
import {
  stateEntityAdapter,
  createSelectUiDeviceState,
} from '@racepointenergy/swc/scs/features/host-states'
import { useMemo } from 'react'
import { Devices } from './types'
import { parseUiDevicesToDevices } from './utils'

const hostStateInitialState = stateEntityAdapter.getInitialState()

export const useUiDevices = (id: string) => {
  const { data = hostStateInitialState } = dealerMonitorStates.useQuery({ id })

  const { data: uiDevices = [] } = dealerMonitorUserInterfaces.useQuery(
    { id },
    {
      pollingInterval: 1000 * 30, // query for newly discovered UI devices twice a minute
      refetchOnReconnect: true,
    }
  )

  const selectUiDevices = useMemo(
    () => createSelectUiDeviceState(uiDevices),
    [uiDevices]
  )(data)

  const additionalDevices: Devices[] = useMemo(
    () => parseUiDevicesToDevices(selectUiDevices),
    [selectUiDevices]
  )

  return {
    additionalDevices,
    selectUiDevices,
  }
}
